import React, { Component } from 'react';
import './Input.css';
import Validation from '../../components/validation/Validation';
import FontIcon from '../../components/fontIcon/FontIcon';
import utils from '../../utils/utils';

export default class Input extends Component {
	constructor(props) {
		super(props);
		const {disabled = false} = this.props
		this.state = {
      id: utils.uuid(),
			value: this._defaultValue(),
			valid: true,
			disabled: disabled
		};
	}

	componentDidMount() {
		this.autoSize(this.state.value);
	}

	componentWillReceiveProps = (nextProps) => {
		if (nextProps.value !== this.state.value && nextProps.value !== undefined) {
			this.setState({ value: nextProps.value });
		}
		this.setState({ disabled: nextProps.disabled })
		this.autoSize(nextProps.value);
	};

	getValue = () => {
		return this.state.value;
	};

	_defaultValue = () => {
		if (this._isEmpty(this.props.value)) {
			return '';
		}
		return this.props.value;
	};

	_isEmpty = (value) => {
		if (value === null) return true;
		if (value === undefined) return true;
		if (value === '') return true;
		return false;
	};

	_valueChanged = (e) => {
		let value = e.target.value;
		let length = value.length;
		if (this.props.length && length > this.props.length) return;
		this.setState({ value: value }, () => {
			this.setState({ valid: this._isValid() });
			this.autoSize(value);
		});

		if (this.props.onChange) {
			if (this.props.type === 'date') {
				try {
					new Date(value).toISOString();
				} catch (e) {
					console.error(e);
					return;
				}
			}
			this.props.onChange(value);
		}
	};
	autoSize = (value) => {
		this._autoSize({ target: { value } });
	};
	_autoSize = (e) => {
		let value = e.target.value || this.placeholder() || '';
		let width = utils.getTextWidth('17px', value);

		if (!this.props.autosize) return;
		if (!this.inputElement) return;
		this.inputElement.style.width = width + 46 + 'px';
	};

	getIcon = () => {
		if (this.props.iconName) {
			return <FontIcon color="gray" name={this.props.iconName} />;
		}
	};

	getInputClasses = () => {
		if (this.props.iconName) {
			return 'icon';
		}
		return '';
	};

	getClasses = () => {
		let classes = 'g-input item-input';
		if (this.props.center) {
			classes += ' center';
		}
		classes += ' ' + (this.props.className || '');
		return classes;
	};
	placeholder = () => {
		if (this._isEmpty(this.state.value)) {
			return this.props.placeholder || '';
		}
		return '';
	};
	_isValid = () => {
		let type = this.props.type;
		let val = this.state.value;
		let valid = true;
		let re = null;
		if ((type === undefined || type === 'text') && this.props.required) {
			valid = val !== '';
		} else if (type === 'email') {
			re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		} else if (type === 'number') {
			re = /[+-]?(?=\.\d|\d)(?:\d+)?(?:\.?\d*)(?:[eE][+-]?\d+)?/;
		} else if (type === 'zip') {
			re = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
		} else if (type === 'date') {
			if (val && val.length > 0) valid = true;
			else if (!this.props.required) valid = true;
			else valid = false;
		} else {
			valid = true;
		}
		if (re) {
			valid = re.test(val);
		}
		return valid;
	};

	isValid = () => {
		let valid = this._isValid();
		this.setState({ valid });
		return valid;
	};

	_isInvalidText = () => {
		if (!this.state.valid && this.props.required) {
			return <Validation />;
		}
	};
  focus = () => {
    this.inputElement.focus()
  };

	render() {
		const { min, type } = this.props;
		let otherProps = {
			['data-lpignore']: 'true'
		};
		if (this.props.loginInput) {
			otherProps = {};
		}
		return (
			<div className={this.getClasses()}>
        {this.props.persistantLabel && <label htmlFor={this.state.id}  className={'persistent-label'}>{this.props.placeholder}</label>}
        <input
          id={this.state.id}
					onInput={this._autoSize}
					ref={(ref) => (this.inputElement = ref)}
					onChange={this._valueChanged}
					placeholder={this.placeholder()}
					onBlur={this.props.onBlur}
					value={this.state.value}
					disabled={this.state.disabled}
					min={min}
					type={type}
					{...otherProps}
					className={this.getInputClasses()}
				/>
				{this.getIcon()}
				{this._isInvalidText()}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/inputs/input/Input.jsx